export default __webpack_public_path__ + "static/ironing-dynamic-8bb013b76acd89969c97b23285d0f202.svg";